import React, { useState, useEffect } from "react";

import ReportLayout from "../components/ReportLayout";
import { DateField } from "../components/DateField";
import { SelectField } from "../components/SelectField";

import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";

export default function ExamplerDetails() {
  const [form, setForm] = useState({
    fromDate: "",
    toDate: "",
    district: "",
    deed: "",
  });
  const [districts, setDistricts] = useState([]);
  const [deeds, setDeeds] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/Master/get_District_Mas`)
      .then((res) => setDistricts(res.data.data));
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/Registration/getDeedNames?mode=ALL`)
      .then((res) => {
        setDeeds(res.data);
      });
  }, []);

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));
  const handleDownload = () => console.log(form);

  return (
    <ReportLayout title="Exampler Details" onDownload={handleDownload}>
      <DateField
        id="fromDate"
        label="From Date"
        value={form.fromDate}
        onChange={handleChange("fromDate")}
      />
      <DateField
        id="toDate"
        label="To Date"
        value={form.toDate}
        onChange={handleChange("toDate")}
      />
      <SelectField
        id="district"
        label="Select District"
        value={form.district}
        onChange={handleChange("district")}
        options={districts.map((d) => ({
          value: d.dcode,
          label: d.districtName,
        }))}
      />
      <SelectField
        id="deed"
        label="Select Deed"
        value={form.deed}
        onChange={handleChange("deed")}
        // options={[
        //   { value: "deed1", label: "Deed 1" },
        //   { value: "deed2", label: "Deed 2" },
        // ]}
        options={deeds.map((deed) => ({
          value: deed,
          label: deed,
        }))}
        disabled={deeds.length === 0}
      />
    </ReportLayout>
  );
}
